import { useAuthSigninState } from "../../authSignin/state";
import React, { useEffect } from "react";

export const SocialLogin = () => {
    const { sendEvent } = useAuthSigninState();

    useEffect(() => {
        const socialLoginLinksBlock = document.getElementById("social-login-links-block");
        const socialLoginWrapper = document.getElementById("social-login-wrapper");

        socialLoginWrapper.innerHTML = socialLoginLinksBlock?.innerHTML;

        $('.new-social-signin-button')?.on("click", (event) => {
            sendEvent(`Social Login : ${event?.currentTarget?.getAttribute?.("data-clickedon")}`);
        })
    }, [])

    return (
        <div id="social-login-wrapper"></div>
    )
}